// AI output is untrusted, so only plain web links are rendered as anchors.
export const isSafeExternalUrl = (url?: string | null): url is string => {
    if (!url) {
        return false;
    }
    try {
        const { protocol } = new URL(url);
        return protocol === 'https:' || protocol === 'http:';
    } catch {
        return false;
    }
};
